import {
    LineChart, Line,
    AreaChart, Area, XAxis, YAxis,
    CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine
} from "recharts";
import { TimeSeriesPoint } from "../../models/Dashboard";
import "./DashboardStyleSheet.css";


const ValueTrendCard: React.FC<{ data: TimeSeriesPoint[]; currency: string; }> = ({ data, currency }) => {
    const formatted = data.map(d => ({
        ...d,
        label: new Date(d.date).toLocaleDateString("en-GB", { month: "short", year: "2-digit" }),
        value: d.value,
    }));

    const firstValue = formatted[0]?.value ?? 0;

    const compactNum = (v: number) =>
        new Intl.NumberFormat("en-GB", {
            notation: "compact",
            maximumFractionDigits: 1
        }).format(v);

    return (
        <div className="dashboard-card">
            <div className="dashboard-card-header">
                <h2>Portfolio Value</h2>
                <span className="dashboard-card-subtitle">
                    12-month cumulative · {currency}
                </span>
            </div>
            <div className="dashboard-card-body">
                <ResponsiveContainer width="100%" height={220}>
                    <AreaChart data={formatted}>
                        <defs>
                            <linearGradient id="valueGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#111827" stopOpacity={0.15} />
                                <stop offset="95%" stopColor="#111827" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
                        <XAxis
                            dataKey="label"
                            tick={{ fontSize: 10 }}
                            tickLine={false}
                        />
                        <YAxis
                            tick={{ fontSize: 10 }}
                            tickLine={false}
                            axisLine={false}
                            tickFormatter={compactNum}
                            width={55}
                        />
                        <Tooltip
                            formatter={(v: number) => [
                                new Intl.NumberFormat("en-GB", {
                                    maximumFractionDigits: 0
                                }).format(v),
                                "Portfolio Value"
                            ]}
                            labelStyle={{ fontWeight: 600 }}
                        />
                        {/* Reference line at the opening value */}
                        <ReferenceLine
                            y={firstValue}
                            stroke="#d1d5db"
                            strokeDasharray="4 4"
                        />
                        <Area
                            type="monotone"
                            dataKey="value"
                            stroke="#111827"
                            strokeWidth={2}
                            fill="url(#valueGradient)"
                            dot={false}
                            activeDot={{ r: 4, fill: "#111827" }}
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};
export default ValueTrendCard;